<div class="modal">
  <header class="modal__header">
    <h2 class="modal__header__title" translate>Add Employee</h2>
    <button class="modal__header__close" (click)="_dialogRef.close()">
      <i class="icon icon-close_ico"></i>
    </button>
  </header>

  <div class="modal__content">
    <form [formGroup]="form" class="assign-container">
      <div appFormControlError="employee" class="employee__control-container form-group">
        <div class="employee__control-label" translate>
          Employee
          <span class="employee__control-required">*</span>
        </div>

        <app-select
          valueKey="id"
          displayKey="full_name"
          [placeholder]="'Select Employee' | translate"
          formControlName="employee"
          [withNone]="false"
          [model]="employeeModel"
          [collection]="employersCollection"
          [optionList]="employersCollection.items"
          (refreshCallback)="getEmployeesList($event)"
          (selectedValue)="employeeControl.markAsDirty()">
        </app-select>
      </div>
    </form>
  </div>

  <div class="modal__actions mt-3">
    <div class="btn-group row-flex row-flex--middle mx-0">
      <button class="btn btn__bordered mr-2" (click)="_dialogRef.close()" translate>Cancel</button>
      <btn-loader
        styleClasses="btn__primary"
        [buttonLabel]="'Add' | translate"
        [disabled]="!this.employeeControl.valid"
        [class.disabled]="!this.employeeControl.valid"
        [loading]="(collection.loadingCrud$ | async).updating"
        (applyAction)="submit()"></btn-loader>
    </div>
  </div>
</div>
